class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		//console.log("FacetFiltersForm constructor");
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			//console.log("debouncedOnSubmit triggered", event);
			this.onSubmitHandler(event);
		}, 800);

		const facetForm = this.querySelector("form");
		facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
	}

	static setListeners() {
		//console.log("FacetFiltersForm.setListeners");
		const onHistoryChange = (event) => {
			//console.log("onHistoryChange", event);
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		//console.log("toggleActiveFacets", disable);
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		//console.log("renderPage", { searchParams, event, updateURLHash });
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		const loadingSpinners = document.querySelectorAll(
			".facets-container .loading__spinner, facet-filters-form .loading__spinner"
		);

		loadingSpinners.forEach((spinner) =>
			spinner.classList.remove("hidden")
		);
		document
			.getElementById("ProductGridContainer")
			.querySelector(".collection")
			.classList.add("loading");
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		searchParams = FacetFiltersForm.handleDimensionsParam(searchParams);

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			// console.log(url);
			const filterDataUrl = (element) => element.url === url;

			if (FacetFiltersForm.filterData.some(filterDataUrl)) {
				//console.log("renderSectionFromCache", url);
				FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
			} else {
				//console.log("renderSectionFromFetch", url);
				FacetFiltersForm.renderSectionFromFetch(url, event);
			}
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}
	static handleDimensionsParam(initialSearchParams) {
		let searchParams = new URLSearchParams(initialSearchParams);
		// console.log(
		// 	"[handleDimensionsParam] initialSearchParams:",
		// 	initialSearchParams
		// );

		const widthFilterParam = "filter-p-m-custom-width";
		const heightFilterParam = "filter-p-m-custom-height";
		const lengthFilterParam = "filter-p-m-custom-length";

		function checkParamExists(param, type) {
			const modifiedParam = param.concat(`-${type}`).replace(/-/g, ".");
			const exists = searchParams.has(modifiedParam);
			// console.log(
			// 	`[handleDimensionsParam] checkParamExists: ${modifiedParam} exists?`,
			// 	exists
			// );
			return exists;
		}

		const widthLTEExists = checkParamExists(widthFilterParam, "lte");
		const heightLTEExists = checkParamExists(heightFilterParam, "lte");
		const lengthLTEExists = checkParamExists(lengthFilterParam, "lte");
		const widthGTEExists = checkParamExists(widthFilterParam, "gte");
		const heightGTEExists = checkParamExists(heightFilterParam, "gte");
		const lengthGTEExists = checkParamExists(lengthFilterParam, "gte");

		if (
			!widthGTEExists &&
			!heightGTEExists &&
			!lengthGTEExists &&
			!widthLTEExists &&
			!heightLTEExists &&
			!lengthLTEExists
		) {
			// console.log(
			// 	"[handleDimensionsParam] Ending early, no dimension params found"
			// );
			return initialSearchParams;
		}

		const widthDataset = document
			.querySelector(
				`.dataset__filter-values[data-filter="${widthFilterParam}"]`
			)
			.getAttribute("data-values");
		const widthData = widthDataset.split(",").map((v) => Number(v.trim()));
		// console.log("[handleDimensionsParam] widthData:", widthData);

		const heightDataset = document
			.querySelector(
				`.dataset__filter-values[data-filter="${heightFilterParam}"]`
			)
			.getAttribute("data-values");
		const heightData = heightDataset
			.split(",")
			.map((v) => Number(v.trim()));
		//console.log("[handleDimensionsParam] heightData:", heightData);

		const lengthDataset = document
			.querySelector(
				`.dataset__filter-values[data-filter="${lengthFilterParam}"]`
			)
			.getAttribute("data-values");
		const lengthData = lengthDataset
			.split(",")
			.map((v) => Number(v.trim()));
		//console.log("[handleDimensionsParam] lengthData:", lengthData);

		const widthDataMin = Math.min(
			...document
				.querySelector(
					`.dataset__filter-values[data-filter="${widthFilterParam}"]`
				)
				.getAttribute("data-values")
				.split(",")
				.map((val) => parseInt(val.trim()))
		);
		const widthDataMax = Math.max(
			...document
				.querySelector(
					`.dataset__filter-values[data-filter="${widthFilterParam}"]`
				)
				.getAttribute("data-values")
				.split(",")
				.map((val) => parseInt(val.trim()))
		);

		const lengthDataMin = Math.min(
			...document
				.querySelector(
					`.dataset__filter-values[data-filter="${lengthFilterParam}"]`
				)
				.getAttribute("data-values")
				.split(",")
				.map((val) => parseInt(val.trim()))
		);
		const lengthDataMax = Math.max(
			...document
				.querySelector(
					`.dataset__filter-values[data-filter="${lengthFilterParam}"]`
				)
				.getAttribute("data-values")
				.split(",")
				.map((val) => parseInt(val.trim()))
		);
		const heightDataMin = Math.min(
			...document
				.querySelector(
					`.dataset__filter-values[data-filter="${heightFilterParam}"]`
				)
				.getAttribute("data-values")
				.split(",")
				.map((val) => parseInt(val.trim()))
		);
		const heightDataMax = Math.max(
			...document
				.querySelector(
					`.dataset__filter-values[data-filter="${heightFilterParam}"]`
				)
				.getAttribute("data-values")
				.split(",")
				.map((val) => parseInt(val.trim()))
		);

		//console.log(
		// 	"[handleDimensionsParam] widthDataMin:",
		// 	widthDataMin,
		// 	"widthDataMax:",
		// 	widthDataMax
		// );
		//console.log(
		// 	"[handleDimensionsParam] heightDataMin:",
		// 	heightDataMin,
		// 	"heightDataMax:",
		// 	heightDataMax
		// );
		//console.log(
		// 	"[handleDimensionsParam] lengthDataMin:",
		// 	lengthDataMin,
		// 	"lengthDataMax:",
		// 	lengthDataMax
		// );

		const widthGTE = Number(
			searchParams.get(`${widthFilterParam.replace(/-/g, ".")}.gte`)
		);
		const widthLTE = Number(
			searchParams.get(`${widthFilterParam.replace(/-/g, ".")}.lte`)
		);

		const heightGTE = Number(
			searchParams.get(`${heightFilterParam.replace(/-/g, ".")}.gte`)
		);
		const heightLTE = Number(
			searchParams.get(`${heightFilterParam.replace(/-/g, ".")}.lte`)
		);

		const lengthGTE = Number(
			searchParams.get(`${lengthFilterParam.replace(/-/g, ".")}.gte`)
		);
		const lengthLTE = Number(
			searchParams.get(`${lengthFilterParam.replace(/-/g, ".")}.lte`)
		);

		//console.log(
		// 	"[handleDimensionsParam] widthGTE:",
		// 	widthGTE,
		// 	"widthLTE:",
		// 	widthLTE
		// );
		//console.log(
		// 	"[handleDimensionsParam] heightGTE:",
		// 	heightGTE,
		// 	"heightLTE:",
		// 	heightLTE
		// );
		//console.log(
		// 	"[handleDimensionsParam] lengthGTE:",
		// 	lengthGTE,
		// 	"lengthLTE:",
		// 	lengthLTE
		// );

		const filteredWidth = widthData.filter(
			(val) =>
				(!isNaN(widthGTE) ? val >= widthGTE : true) &&
				(!isNaN(widthLTE) ? val <= widthLTE : true)
		);
		const filteredHeight = heightData.filter(
			(val) =>
				(!isNaN(heightGTE) ? val >= heightGTE : true) &&
				(!isNaN(heightLTE) ? val <= heightLTE : true)
		);
		const filteredLength = lengthData.filter(
			(val) =>
				(!isNaN(lengthGTE) ? val >= lengthGTE : true) &&
				(!isNaN(lengthLTE) ? val <= lengthLTE : true)
		);

		//console.log("[handleDimensionsParam] filteredWidth:", filteredWidth);
		//console.log("[handleDimensionsParam] filteredHeight:", filteredHeight);
		//console.log("[handleDimensionsParam] filteredLength:", filteredLength);

		if (
			filteredWidth.length > 0 &&
			(widthGTE != 0 || widthLTE != widthDataMax)
		) {
			//console.log(
			// 	"[handleDimensionsParam] Appending filteredWidth values"
			// );
			filteredWidth.forEach((value) => {
				searchParams.append(widthFilterParam.replace(/-/g, "."), value);
			});
		} else if (
			filteredWidth.length <= 0 &&
			(widthGTE != 0 || widthLTE != widthDataMax) &&
			widthGTEExists &&
			widthLTEExists
		) {
			//console.log(
			// 	"[handleDimensionsParam] Appending no-products for width"
			// );
			searchParams.append(
				widthFilterParam.replace(/-/g, "."),
				"no-products"
			);
		}

		if (
			filteredHeight.length > 0 &&
			(heightGTE != 0 || heightLTE != heightDataMax)
		) {
			//console.log(
			// 	"[handleDimensionsParam] Appending filteredHeight values"
			// );
			filteredHeight.forEach((value) => {
				searchParams.append(
					heightFilterParam.replace(/-/g, "."),
					value
				);
			});
		} else if (
			filteredHeight.length <= 0 &&
			(heightGTE != 0 || heightLTE != heightDataMax) &&
			heightGTEExists &&
			heightLTEExists
		) {
			//console.log(
			// 	"[handleDimensionsParam] Appending no-products for height"
			// );
			searchParams.append(
				heightFilterParam.replace(/-/g, "."),
				"no-products"
			);
		}

		if (
			filteredLength.length > 0 &&
			(lengthGTE != 0 || lengthLTE != lengthDataMax)
		) {
			//console.log(
			// 	"[handleDimensionsParam] Appending filteredLength values"
			// );
			filteredLength.forEach((value) => {
				searchParams.append(
					lengthFilterParam.replace(/-/g, "."),
					value
				);
			});
		} else if (
			filteredLength.length <= 0 &&
			(lengthGTE != 0 || lengthLTE != lengthDataMax) &&
			lengthGTEExists &&
			lengthLTEExists
		) {
			//console.log(
			// 	"[handleDimensionsParam] Appending no-products for length"
			// );
			searchParams.append(
				lengthFilterParam.replace(/-/g, "."),
				"no-products"
			);
		}

		//console.log(
		// 	"[handleDimensionsParam] searchParams before deduplication:",
		// 	searchParams.toString()
		// );

		const seen = new Set();
		const uniqueParams = new URLSearchParams();

		for (const [key, value] of searchParams.entries()) {
			const keyVal = `${key}=${value}`;
			if (!seen.has(keyVal)) {
				seen.add(keyVal);
				uniqueParams.append(key, value);
			}
		}

		//console.log(
		// 	"[handleDimensionsParam] uniqueParams:",
		// 	uniqueParams.toString()
		// );

		return uniqueParams.toString();
	}

	static renderSectionFromFetch(url, event) {
		//console.log("renderSectionFromFetch", url);
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
				if (typeof initializeScrollAnimationTrigger === "function")
					initializeScrollAnimationTrigger(html.innerHTML);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		//console.log("renderSectionFromCache");
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
		if (typeof initializeScrollAnimationTrigger === "function")
			initializeScrollAnimationTrigger(html.innerHTML);
	}

	static renderProductGridContainer(html) {
		//console.log("renderProductGridContainer");
		document.getElementById("ProductGridContainer").innerHTML =
			new DOMParser()
				.parseFromString(html, "text/html")
				.getElementById("ProductGridContainer").innerHTML;

		document
			.getElementById("ProductGridContainer")
			.querySelectorAll(".scroll-trigger")
			.forEach((element) => {
				element.classList.add("scroll-trigger--cancel");
			});
	}

	static renderProductCount(html) {
		//console.log("renderProductCount");
		const count = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductCount").innerHTML;
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		container.innerHTML = count;
		container.classList.remove("loading");
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}
		const loadingSpinners = document.querySelectorAll(
			".facets-container .loading__spinner, facet-filters-form .loading__spinner"
		);
		loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
	}

	static renderFilters(html, event) {
		//console.log("renderFilters", { html, event });
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const facetDetailsElementsFromDom = document.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);

		// Remove facets that are no longer returned from the server
		Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
			if (
				!Array.from(facetDetailsElementsFromFetch).some(
					({ id }) => currentElement.id === id
				)
			) {
				//console.log("Removing facet from DOM", currentElement.id);
				currentElement.remove();
			}
		});

		const matchesId = (element) => {
			const jsFilter = event
				? event.target.closest(".js-filter")
				: undefined;
			return jsFilter ? element.id === jsFilter.id : false;
		};

		const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
			(element) => !matchesId(element)
		);
		const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
			matchesId
		);

		facetsToRender.forEach((elementToRender, index) => {
			const currentElement = document.getElementById(elementToRender.id);
			// Element already rendered in the DOM so just update the innerHTML
			if (currentElement) {
				//console.log("Updating facet innerHTML", elementToRender.id);
				document.getElementById(elementToRender.id).innerHTML =
					elementToRender.innerHTML;
			} else {
				if (index > 0) {
					const {
						className: previousElementClassName,
						id: previousElementId,
					} = facetsToRender[index - 1];
					// Same facet type (eg horizontal/vertical or drawer/mobile)
					if (
						elementToRender.className === previousElementClassName
					) {
						//console.log(
						//	"Inserting after previous element",
						//	previousElementId
						//);
						document
							.getElementById(previousElementId)
							.after(elementToRender);
						return;
					}
				}

				if (elementToRender.parentElement) {
					//console.log(
					//	"Inserting before in parent",
					//	elementToRender.parentElement.id
					//);
					document
						.querySelector(
							`#${elementToRender.parentElement.id} .js-filter`
						)
						.before(elementToRender);
				}
			}
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender) {
			const closestJSFilterID = event.target.closest(".js-filter").id;

			if (closestJSFilterID) {
				//console.log("Rendering counts for", closestJSFilterID);
				FacetFiltersForm.renderCounts(
					countsToRender,
					event.target.closest(".js-filter")
				);
				FacetFiltersForm.renderMobileCounts(
					countsToRender,
					document.getElementById(closestJSFilterID)
				);

				const newFacetDetailsElement =
					document.getElementById(closestJSFilterID);
				const newElementSelector =
					newFacetDetailsElement.classList.contains(
						"mobile-facets__details"
					)
						? `.mobile-facets__close-button`
						: `.facets__summary`;
				const newElementToActivate =
					newFacetDetailsElement.querySelector(newElementSelector);

				const isTextInput =
					event.target.getAttribute("type") === "text";

				if (newElementToActivate && !isTextInput)
					newElementToActivate.focus();
			}
		}
	}

	static renderActiveFacets(html) {
		//console.log("renderActiveFacets");
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		//console.log("renderAdditionalElements");
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});

		document
			.getElementById("FacetFiltersFormMobile")
			.closest("menu-drawer")
			.bindEvents();
	}

	static renderCounts(source, target) {
		//console.log("renderCounts");
		const targetSummary = target.querySelector(".facets__summary");
		const sourceSummary = source.querySelector(".facets__summary");

		if (sourceSummary && targetSummary) {
			targetSummary.outerHTML = sourceSummary.outerHTML;
		}

		const targetHeaderElement = target.querySelector(".facets__header");
		const sourceHeaderElement = source.querySelector(".facets__header");

		if (sourceHeaderElement && targetHeaderElement) {
			targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
		}

		const targetWrapElement = target.querySelector(".facets-wrap");
		const sourceWrapElement = source.querySelector(".facets-wrap");

		if (sourceWrapElement && targetWrapElement) {
			const isShowingMore = Boolean(
				target.querySelector("show-more-button .label-show-more.hidden")
			);
			if (isShowingMore) {
				sourceWrapElement
					.querySelectorAll(".facets__item.hidden")
					.forEach((hiddenItem) =>
						hiddenItem.classList.replace("hidden", "show-more-item")
					);
			}

			targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
		}
	}

	static renderMobileCounts(source, target) {
		//console.log("renderMobileCounts");
		const targetFacetsList = target.querySelector(".mobile-facets__list");
		const sourceFacetsList = source.querySelector(".mobile-facets__list");

		if (sourceFacetsList && targetFacetsList) {
			targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		//console.log("updateURLHash", searchParams);
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${
				searchParams && "?".concat(searchParams)
			}`
		);
	}

	static getSections() {
		//console.log("getSections");
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	createSearchParams(form) {
		//console.log("createSearchParams", form);
		const formData = new FormData(form);
		//console.log(formData);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		//console.log("onSubmitForm", searchParams, event);
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		//console.log("onSubmitHandler", event);
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			"facet-filters-form form"
		);
		if (event.srcElement.className == "mobile-facets__checkbox") {
			const searchParams = this.createSearchParams(
				event.target.closest("form")
			);
			//console.log("Search Params: ", searchParams);
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const isMobile =
				event.target.closest("form").id === "FacetFiltersFormMobile";

			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (
						form.id === "FacetSortForm" ||
						form.id === "FacetFiltersForm" ||
						form.id === "FacetSortDrawerForm"
					) {
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === "FacetFiltersFormMobile") {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join("&"), event);
		}
	}

	onActiveFilterClick(event) {
		//console.log("onActiveFilterClick", event);
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		//console.log("PriceRange constructor");
		this.querySelectorAll("input").forEach((element) => {
			element.addEventListener("change", this.onRangeChange.bind(this));
			element.addEventListener("keydown", this.onKeyDown.bind(this));
		});
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		//console.log("onRangeChange", event);
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	onKeyDown(event) {
		//console.log("onKeyDown", event);
		if (event.metaKey) return;

		const pattern =
			/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
		if (!event.key.match(pattern)) event.preventDefault();
	}

	setMinAndMaxValues() {
		//console.log("setMinAndMaxValues");
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("data-min", 0);
		if (maxInput.value === "")
			minInput.setAttribute(
				"data-max",
				maxInput.getAttribute("data-max")
			);
	}

	adjustToValidValues(input) {
		//console.log("adjustToValidValues", input);
		const value = Number(input.value);
		const min = Number(input.getAttribute("data-min"));
		const max = Number(input.getAttribute("data-max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		//console.log("FacetRemove constructor");
		const facetLink = this.querySelector("a");
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		//console.log("closeFilter", event);
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		form.onActiveFilterClick(event);
	}
}

customElements.define("facet-remove", FacetRemove);
